import { render, staticRenderFns } from "./handList.vue?vue&type=template&id=4b634964&scoped=true&"
import script from "./handList.vue?vue&type=script&lang=js&"
export * from "./handList.vue?vue&type=script&lang=js&"
import style0 from "./handList.vue?vue&type=style&index=0&id=4b634964&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b634964",
  null
  
)

export default component.exports